import { FC, ReactNode, createContext, useMemo, useState } from 'react';
import { CompleteApiResponseData } from 'src/services/useCompleteInvoiceApi';
import { SetState } from 'src/types/generic';

interface ViewInvoiceContextType {
  completeApiResponseData: CompleteApiResponseData;
  setCompleteApiResponseData: SetState<CompleteApiResponseData>;
}

export const ViewInvoiceContext = createContext<ViewInvoiceContextType>(
  {} as ViewInvoiceContextType
);

interface ViewInvoiceContextProps {
  children: ReactNode;
}

const ViewInvoiceContextProvider: FC<ViewInvoiceContextProps> = ({ children }) => {
  const [completeApiResponseData, setCompleteApiResponseData] = useState<CompleteApiResponseData>({
    processedIds: [],
    unProcessed: [],
  });
  const providerValues = useMemo(
    () => ({
      completeApiResponseData,
      setCompleteApiResponseData,
    }),
    [completeApiResponseData]
  );

  return (
    <ViewInvoiceContext.Provider value={providerValues}>{children}</ViewInvoiceContext.Provider>
  );
};

export default ViewInvoiceContextProvider;
